module.exports = __webpack_public_path__ + "img/send.4f9ef920.svg";